module.exports = __webpack_public_path__ + "static/media/ic-info.894785f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/ic-info.svg
// module id = 681
// module chunks = 0